// extracted by mini-css-extract-plugin
export default {"sectorText":"Footer_sectorText__ghLVO","nemad":"Footer_nemad__lvHb0","logo":"Footer_logo__ekbR9"};